import React, { useMemo } from 'react';

import NukaCarousel from '@r1-frontend/ui-react/components/NukaCarousel';
import { EMediaWidth } from '@r1-frontend/ui-react/tokens/mediaWidth';
import { useMatchMedia } from '@r1-frontend/shared/hooks/useMatchMedia';

import { COUNT_SLIDE_MOBILE, COUNT_SLIDE_TABLET } from '~/src/features/yandex-landing/constants';
import { sliderPropsCatalog } from '~/src/features/yandex-landing/data';
import type { IProps } from '~/src/features/yandex-landing/YandexStationCards/types';

import { YandexStationCard } from './YandexStationCard';

const YandexStationCards: React.FC<IProps> = ({ yandexStationDataSorted, startLine, endLine, isCarousel }) => {
    const isSDesktop = useMatchMedia(EMediaWidth.sDesktopOnly);
    const isMobile = useMatchMedia(EMediaWidth.mobile);

    const countSlides = useMemo((): number => {
        switch (true) {
            case isSDesktop:
                return sliderPropsCatalog.slidesToShow;
            case isMobile:
                return COUNT_SLIDE_MOBILE;
            default:
                return COUNT_SLIDE_TABLET;
        }
    }, [isSDesktop, isMobile]);

    const yandexCards = useMemo((): JSX.Element[] => {
        return (
            yandexStationDataSorted.map((item) => <YandexStationCard key={item.id} item={item}/>)
        );
    }, [yandexStationDataSorted]);

    const getYandexCardsCarousel = (startLine: number, endLine: number): JSX.Element => {
        const cards = [];
        for (let i = startLine; i < endLine; i++) {
            if (yandexStationDataSorted[i]) {
                cards.push(<YandexStationCard item={yandexStationDataSorted[i]}/>);
            }
        }

        return (
            cards.length > countSlides
                ? <NukaCarousel {...sliderPropsCatalog} slidesToShow={countSlides}>
                    {cards}
                </NukaCarousel>
                : <>{cards}</>
        );
    };

    return (
        <>
            { isCarousel ? getYandexCardsCarousel(startLine as number, endLine as number) : yandexCards}
        </>
    );
};

export default YandexStationCards;
